import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Award } from 'lucide-react';
export function BlackBeltClubPage() {
  const blackBelts = [{
    name: 'Master Michael Atchison',
    image: 'https://static.wixstatic.com/media/a88700_78ccb1de1ef14b94bca7669d08a2a1d0~mv2.jpeg'
  }, {
    name: 'Master Mark Kanaar',
    image: 'https://static.wixstatic.com/media/a09ac0_2de382b388f54533893cf9a7f204b6e4~mv2.jpg'
  }, {
    name: 'Master Cindy Gohsman',
    image: 'https://static.wixstatic.com/media/a88700_39c82ccceccf4f0aa37a7864f0cf6726~mv2.jpeg/v1/fill/w_463,h_617,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Cindy%20Gohsman.jpeg'
  }, {
    name: 'Master Daniel Foster',
    image: 'https://static.wixstatic.com/media/fcd869_3b809ebd4a3742aa8171ba6d0ebccdd1~mv2.png/v1/fill/w_463,h_617,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Master%20Daniel%20Foster.png'
  }, {
    name: 'Master Eric Reynolds',
    image: 'https://static.wixstatic.com/media/fcd869_e23061be7618436690f5ef3820ccaa2c~mv2.jpg/v1/fill/w_463,h_617,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Eric%20Reynolds.jpg'
  }, {
    name: 'Mr. Chad Kilbourn',
    image: 'https://static.wixstatic.com/media/fcd869_fef2144520cb47158903bf1766541371~mv2.jpg/v1/fill/w_463,h_617,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Chad%20Kilbourn.jpg'
  }, {
    name: 'Mrs. Roxy Kilbourn',
    image: 'https://static.wixstatic.com/media/fcd869_72a6286ad5504735a7ab58368cb2c6a7~mv2.jpg/v1/fill/w_463,h_617,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Roxy%20Kilbourn.jpg'
  }, {
    name: 'Mr. Joey Skutt',
    image: 'https://static.wixstatic.com/media/fcd869_b684b6fb5ea5492eb14fd61440baade3~mv2.jpg/v1/fill/w_463,h_617,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Joey%20Skutt.jpg'
  }, {
    name: 'Mrs. Deb Foutch',
    image: 'https://static.wixstatic.com/media/fcd869_24216ad361aa46d98418833b874c6011~mv2.jpg/v1/fill/w_463,h_617,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Deb%20Foutch.jpg'
  }, {
    name: 'Mr. Matt Foutch',
    image: 'https://static.wixstatic.com/media/fcd869_1e7bb9960a3e4e678807d51415dfc4bb~mv2.jpg/v1/fill/w_463,h_617,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Matt%20Foutch.jpg'
  }, {
    name: 'Mr. Troy Foutch',
    image: 'https://static.wixstatic.com/media/fcd869_6fb39f864aa54529a41e75773bb7be1d~mv2.jpg/v1/fill/w_463,h_617,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Troy%20Foutch.jpg'
  }, {
    name: 'Mrs. Anna Garcia',
    image: 'https://static.wixstatic.com/media/fcd869_8881ad623ae5468d994434b155b36813~mv2.jpg/v1/fill/w_463,h_617,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Anna%20Garcia.jpg'
  }, {
    name: 'Mr. Alec Strickland',
    image: 'https://static.wixstatic.com/media/a09ac0_727ce1b3973b4e6ca9a8d74369636bce~mv2.jpg/v1/fill/w_463,h_617,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Alec%20Strickland.jpg'
  }, {
    name: 'Mr. Bob Wegner',
    image: 'https://static.wixstatic.com/media/fcd869_71172868f156450b846071840e1f2aa0~mv2.jpg/v1/fill/w_463,h_617,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Bob%20Wegner.jpg'
  }, {
    name: 'Mr. Lucas Chaddah',
    image: 'https://static.wixstatic.com/media/a09ac0_2ebb4f47804b4d8382c5831e49a6739b~mv2.jpg/v1/fill/w_463,h_617,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Lucas%20Chaddah.jpg'
  }, {
    name: 'Mrs. Joy Von Matt',
    image: 'https://static.wixstatic.com/media/a88700_02c3331882224bc1a65f167b4b23a6b2~mv2.jpg/v1/fill/w_463,h_617,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Joy%20Von%20Matt.jpg'
  }, {
    name: 'Mrs. Audrey Martin',
    image: 'https://static.wixstatic.com/media/a88700_39c82ccceccf4f0aa37a7864f0cf6726~mv2.jpeg/v1/fill/w_463,h_617,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Audrey%20Martin.jpeg'
  }];
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-711">
      <Header data-id="element-712" />

      <main className="pt-20" data-id="element-713">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-slate-900 to-slate-800 text-white py-20" data-id="element-714">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-715">
            <div className="inline-flex items-center justify-center p-3 bg-white/10 rounded-full mb-6" data-id="element-716">
              <Award className="h-6 w-6 text-[#dc2626]" data-id="element-717" />
            </div>

            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-718">Black Belts</h1>

            <p className="text-lg text-slate-200 max-w-2xl mx-auto" data-id="element-719">
              Meet our accomplished black belt instructors who lead by example
              and inspire excellence in every student.
            </p>
          </div>
        </section>

        {/* Black Belt Grid */}
        <section className="py-16 bg-white" data-id="element-720">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-721">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-722">
              {blackBelts.map((blackBelt, index) => <div key={index} className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-723">
                  <div className="aspect-[3/4] bg-slate-100" data-id="element-724">
                    <img src={blackBelt.image} alt={blackBelt.name} className="w-full h-full object-cover" data-id="element-725" />
                  </div>
                  <div className="p-6 text-center" data-id="element-726">
                    <h3 className="text-lg font-bold text-[#dc2626]" data-id="element-727">
                      {blackBelt.name}
                    </h3>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-728" />
    </div>;
}